var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeicing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7631 1.78588L8.99997 2.80383V5.11323L9.99999 5.69059L12 4.53591L12 2.50001L14 2.50001L14 4.53589L15.7631 5.55385L14.7631 7.2859L13 6.26795L11 7.42265V8.57735L13 9.73205L14.7631 8.7141L15.7631 10.4461L14 11.4641V13.5H12V11.4641L9.99997 10.3094L8.99997 10.8867V13.1961L10.7631 14.2141L9.76311 15.9461L7.99999 14.9282L6.23683 15.9462L5.23683 14.2141L6.99997 13.1962V10.8867L5.99999 10.3094L3.99997 11.4641L3.99997 13.5H1.99997L1.99997 11.4641L0.236816 10.4462L1.23682 8.71411L2.99995 9.73206L4.99997 8.57735V7.42264L2.99999 6.26795L1.23685 7.2859L0.236847 5.55385L1.99997 4.53591L1.99997 2.5H3.99997L3.99997 4.53589L5.99997 5.69059L6.99997 5.11324V2.80385L5.23684 1.7859L6.23684 0.0538512L7.99996 1.07179L9.76311 0.053833L10.7631 1.78588ZM8.99997 8C8.99997 8.55228 8.55225 9 7.99997 9C7.44768 9 6.99997 8.55228 6.99997 8C6.99997 7.44771 7.44768 7 7.99997 7C8.55225 7 8.99997 7.44771 8.99997 8Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeicing);
export default __webpack_public_path__ + "static/media/deicing.7cb052c28c08cccda8aa7a9592a990c1.svg";
export { ForwardRef as ReactComponent };